import {
  MAIN_CURRENCY,
  PLATFORM_FEE_CURRENCY,
  SystemCurrency,
  UserBalance,
  getRegularCurrencies,
} from '@okletsplay/core';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { createSelector } from 'reselect';
import { UserPaymentAccountsState } from './interfaces';
import { MultiCurrencyConfig } from 'config/multi-currency-config';
import { PAYMENT_ACCOUNTS_DISPLAY_ORDER, PAYMENT_ACCOUNT_LAST_ORDER } from './constants';
import { sortBy } from 'lodash';

const balancesState = (state: AppState): UserPaymentAccountsState =>
  state[EntityStoreName.UserPaymentAccounts];

export const userPaymentAccountsSelector = {
  all: createSelector(balancesState, ({ entities }) => Object.values(entities)),
  /**
   * @deprecated This may be not valid selector considering CurrencyType introduced.
   */
  mainAccount: createSelector(balancesState, ({ entities }: UserPaymentAccountsState) => {
    const account = entities[MAIN_CURRENCY];
    return account
      ? {
          amount: account.balance,
          rewardBalance: account.rewardBalance,
          currency: account.currency,
        }
      : account;
  }),
  /**
   * @deprecated This may be not valid selector considering CurrencyType introduced.
   */
  platformFeeAccount: createSelector(balancesState, ({ entities }: UserPaymentAccountsState) => {
    const account = entities[PLATFORM_FEE_CURRENCY];
    return account
      ? {
          amount: account.balance,
          currency: account.currency,
        }
      : account;
  }),
  getActiveAccounts: createSelector(balancesState, ({ entities }: UserPaymentAccountsState) => {
    const currenciesList = getRegularCurrencies(MultiCurrencyConfig.currencyType());

    const result = Object.entries(entities)
      .filter(([key]) => currenciesList.includes(key as SystemCurrency))
      .map((entry) => entry[1]) as UserBalance[];

    return sortBy(
      result,
      (account) => PAYMENT_ACCOUNTS_DISPLAY_ORDER[account.currency] ?? PAYMENT_ACCOUNT_LAST_ORDER
    );
  }),

  getSupportedAccounts: createSelector(balancesState, ({ entities }: UserPaymentAccountsState) => {
    const result = Object.entries(entities).map((entry) => entry[1]) as UserBalance[];

    return sortBy(
      result,
      (account) => PAYMENT_ACCOUNTS_DISPLAY_ORDER[account.currency] ?? PAYMENT_ACCOUNT_LAST_ORDER
    );
  }),

  depositAddress: createSelector(balancesState, ({ entities }: UserPaymentAccountsState) => {
    return (
      entities[MAIN_CURRENCY]?.depositAddress ?? entities[PLATFORM_FEE_CURRENCY]?.depositAddress
    );
  }),
};
